<div class="main-container">
  <div class="ui middle aligned center aligned grid">
    <div class="login-container">
      <div class="login-content">
        <div class="confirm-email-icon">
          <i class="mail outline icon"></i>
        </div>
        <h1>Almost there!<br>Check your inbox</h1>
        <p>We've sent a confirmation email to<br>&lt;{{ email }}&gt;</p>
        <p>Once you've verified your account you'll be able to use Smardie.</p>

        <hr>
        <p>Already have an account? <router-link :to="{name: 'Login'}"><a class="primary">Login Now</a></router-link></p>
      </div>
    </div>
  </div>
</div>
